import { AccordionOptionsType } from "@/types/ModuleOptionsType";
import { columnSize } from "../../utils/layout/columnSize";
import { AccordionItems } from "./AccordionItems";
import { customSanitize } from "../../utils/customSanitize";
import { Modul_Akkordeon } from "../../wp/types/acf-module-types";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { Section } from "@/components/Section/Section";
import { Headline } from "@/components/Headline/Headline";

export type AccordionModuleType = Modul_Akkordeon;

export type AccordionElementType = {
  title: string;
  content: string;
};

interface AccordionProps {
  data: AccordionModuleType;
  accordionOptions: AccordionOptionsType;
  index: number;
}
const Accordion = ({ data, accordionOptions, index }: AccordionProps) => {
  const {
    id,
    section_padding_class,
    section_margin_class,
    background_color_class,
    module_width,
    headline_text_align_class,
  } = data.layout;

  const {
    border_line,
    columns,
    separator,
    box_color,
    show_overline_subline,
    button_type,
    show_extended_link,
  } = accordionOptions ?? {};

  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline,
  );

  const { headline, headline_html_tag, overline, content, elements, subline } =
    data.accordion;
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);

  if (isHidden) {
    return null;
  }

  return (
    <>
      <Section
        className={`accordion ${module_width} ${background_color_class} ${section_padding_class} ${section_margin_class}`}
        columnsClassName="is-multiline is-centered"
        frameless={module_width === "frameless"}
        id={id}
      >
        <div
          className={`column  ${module_width === "narrow-frame" ? columnSize(columns) : "is-12"}`}
        >
          {/* jscpd:ignore-start */}
          <Headline
            headline_html_tag={headline_html_tag}
            headline={headline}
            overline={showOverline ? overline : ""}
            subline={showSubline ? subline : ""}
            extraClass={headline_text_align_class}
            wrapInSection={module_width === "frameless"}
            disableAnimation
          />
          {content && (
            <div
              dangerouslySetInnerHTML={{ __html: customSanitize(content) }}
            />
          )}
          {/* jscpd:ignore-end */}
          <AccordionItems
            elements={elements || []}
            border_line={{
              color: border_line.color || "",
              height: border_line.height || 0,
            }}
            separator={separator}
            box_color={box_color || ""}
            moduleIndex={index}
            showExtendedLink={show_extended_link}
            buttonType={button_type}
          />
        </div>
      </Section>
    </>
  );
};

export default Accordion;
